<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Bioinsumos from '../components/Bioinsumos.vue'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { modalidades, culturas, tiposCriacao, especiesFlorestais } from '@/libs/constants/praticas/opcoesSelects'
import { formataStringYearMonthToBr } from '@/utils/utils'

export default {
  components: {
    AppDisplay,
    Bioinsumos,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    pratica: {
      type: Object
    }
  },
  methods: {
    formataDataInicio (value) {
      if (!value) return ''
      return formataStringYearMonthToBr(value)
    },
    formataModalidadesAdotadas (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => modalidades.find(modalidade => modalidade.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    },
    formataLavouras (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => {
        if (value.cultura === 'OUTROS') {
          return `• Cultura: ${value.especificacaoOutros} / Espaçamento (m): ${value.espacamento}`
        }
        return `• Cultura: ${culturas.find(cultura => cultura.id === value.cultura).nome} / Espaçamento (m): ${value.espacamento}`
      })
      return opcoesFormatadas.join('<br /> ')
    },
    formataPecuarias (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => {
        if (value.tipo === 'OUTROS') {
          return `• Tipo de criação: ${value.especificacaoOutros} / Produtividade: ${value.produtividade}`
        }
        return `• Tipo de criação: ${tiposCriacao.find(tipo => tipo.id === value.tipo).nome} / Produtividade: ${value.produtividade}`
      })
      return opcoesFormatadas.join('<br /> ')
    },
    formataFlorestas (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => {
        if (value.especie === 'OUTROS') {
          return `• Espécie: ${value.outrasEspecies} / Produtividade: ${value.produtividade}`
        }
        return `• Espécie: ${especiesFlorestais.find(especie => especie.id === value.especie).nome} / Produtividade: ${value.produtividade}`
      })
      return opcoesFormatadas.join('<br /> ')
    }
  }
}
</script>

<template>
  <div>
    <div>
      <span class="title-praticas">Dados da prática</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Área (ha):" :content="pratica.area" />
        <app-display v-if="pratica.lavouras.length" label="Atividades agrícolas e produtividade:" :content="formataLavouras(pratica.lavouras)" :isContentInNextLine="true" />
        <app-display v-if="pratica.pecuarias.length" label="Tipo de criação pecuária e produtividade:" :content="formataPecuarias(pratica.pecuarias)" :isContentInNextLine="true" />
        <app-display v-if="pratica.florestas.length" label="Espécies florestais utilizadas e produtividade:" :content="formataFlorestas(pratica.florestas)" :isContentInNextLine="true" />
      </el-col>
      <el-col :span="12">
        <app-display label="Data de início da implementação (mês e ano):" :content="formataDataInicio(pratica.dataInicio)" />
        <app-display label="Modalidade adotada:" :content="formataModalidadesAdotadas(pratica.modalidades)" />
      </el-col>
    </el-row>
    <Bioinsumos :bioinsumo="{utilizaBioinsumos: pratica.utilizaBioinsumos, bioinsumos: pratica.bioinsumos}" />
    <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
    <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
    <Descricao :descricao="pratica.descricao" />
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/ILPF/ILPF.vue